module.exports = __webpack_public_path__ + "static/img/quantijingyin2.b80ecac.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bottom/black/quantijingyin2.png
// module id = kE7Y
// module chunks = 24